<template>
    <div class="plugin-phone-input">
        <div class="plugin-phone-input__container">
            <div class="plugin-phone-input__code">
                <span class="code">+7</span>
            </div>
            <input
                ref="phoneInput"
                v-model="formattedNumber"
                type="tel"
                class="plugin-phone-input__input"
                placeholder="Введите номер телефона"
                maxlength="15"
                v-on:input="formatPhoneNumber"
                v-on:keyup="preventNonDigits"
            />
        </div>
        <div v-if="error" class="plugin-phone-input__error">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'plugin-phone-input',
    props: {
        value: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internalValue: '',
            error: '',
        };
    },
    computed: {
        formattedNumber: {
            get() {
                return this.internalValue;
            },
            set(val) {
                this.internalValue = val;
            },
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.internalValue = this.formatToDisplay(newVal);
                }
            },
        },
    },
    methods: {
        formatPhoneNumber() {
            let value = this.internalValue.replace(/\D/g, '');

            if (value.startsWith('7')) {
                value = value.slice(1);
            } else if (value.startsWith('8')) {
                value = value.slice(1);
            }

            // Оставляем только 10 цифр после +7
            if (value.length > 10) {
                value = value.slice(0, 10);
            }

            let formatted = '';

            if (value.length > 0) {
                formatted = value.replace(
                    /(\d{3})(\d{3})(\d{2})(\d{2})/,
                    '($1) $2-$3-$4'
                );
            }

            this.internalValue = formatted;

            // Эмитим чистое значение (+7XXXXXXXXXX)
            const cleanNumber = '+7' + value;
            this.$emit('input', cleanNumber);

            // this.validate(cleanNumber);
        },

        preventNonDigits(e) {
            if (!/[\d]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                e.preventDefault();
            }
        },

        formatToDisplay(number) {
            if (!number) return '';
            // Убираем +7 если есть
            let digits = number.replace('+7', '').replace(/\D/g, '');
            return digits.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '($1) $2-$3-$4');
        },

        validate(number) {
            if (!this.required && !number) {
                this.error = '';
                return true;
            }

            const digits = number.replace(/\D/g, '');

            if (digits.length !== 11) {
                this.error = 'Номер должен состоять из 11 цифр';
                return false;
            } else {
                this.error = '';
            }

            // Проверка на российские операторы (опционально)
            // const firstDigits = digits.slice(1, 4); // после +7
            // if (!['900', '901', '902', '903', '904', '905', '906', '908', '909', '910',
            //     '911', '912', '913', '914', '915', '916', '917', '918', '919', '920',
            //     '921', '922', '923', '924', '925', '926', '927', '928', '929', '930',
            //     '931', '932', '933', '934', '935', '936', '937', '938', '939', '950',
            //     '951', '952', '953', '954', '955', '956', '957', '958', '959', '960',
            //     '961', '962', '963', '964', '965', '966', '967', '968', '969', '970',
            //     '971', '977', '978', '980', '981', '982', '983', '984', '985', '986',
            //     '987', '988', '989'].includes(firstDigits)) {
            //     this.error = 'Укажите корректный номер российского оператора';
            // } else {
            //     this.error = '';
            // }

            return !this.error;
        },

        // Метод для получения чистого номера извне
        getCleanNumber() {
            return '+7' + this.internalValue.replace(/\D/g, '');
        },

        // Сброс
        reset() {
            this.internalValue = '';
            this.error = '';
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-phone-input {
    width: 600px;

    &__container {
        display: flex;
        align-items: center;
        background: white;
        border: 2px solid #e5e7eb;
        border-radius: 9999px;
        padding: 12px 8px;
        transition: all 0.2s;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

        &:focus-within {
            border-color: @color-primary;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
        }
    }

    &__code {
        .typography-heading();

        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 12px;
        background: #f8fafc;
        border-radius: 9999px;
        border-right: 1px solid #e5e7eb;
        margin-right: 8px;
        color: @color-gray-darker;
    }

    &__input {
        .typography-heading();

        flex: 1;
        border: none;
        outline: none;
        padding: 8px 12px;
        background: transparent;
        color: @color-gray-darker;

        &::placeholder {
            .typography-heading();

            color: @color-gray-darker;
        }
    }

    &__error {
        color: @color-accent-negative;
        font-size: 14px;
        margin-top: 6px;
        padding-left: 12px;
    }

    @media @media-md-down {
        width: 100%;
        &__container {
            padding: 6px 8px;
        }
    }
}
</style>
